/**
 * Vertriebsagentur: targets of notifications. The agency gets to-do notifications on schools (Wiedervorlagen, assigned and
 * completed to-dos); their office targets (/todos/…, /institutions/…) are closed for partner logins. For partner logins
 * (setNotificationPartner, set with the user type) a notification on a school opens the school in the call view, due and
 * overdue follow-ups with the filter „Wiedervorlage fällig“ so „Nächste Schule“ continues with the next due one.
 * Pure module (no store / Vue imports): notificationView.helper is used in node checks.
 */
import {NotificationTypes} from '@/enums/notifier/NotificationTypes';

let partnerLogin = false;

/** Set when the user type is known (store mutation setUserType) */
export function setNotificationPartner(value: boolean): void {
    partnerLogin = value;
}

export function notificationPartner(): boolean {
    return partnerLogin;
}

const OBJECT_ID = /^[0-9a-f]{24}$/i;
const DUE_TYPES: string[] = [NotificationTypes.DUE_TO_DO, NotificationTypes.OVERDUE_TO_DO];

/** Call view of the school a notification (or to-do) is about; undefined when it is not about a school */
export function partnerCallPath(type: string | undefined, entityType: unknown, entityId: unknown): string | undefined {
    const id = entityId && typeof entityId === 'object' && '_id' in (entityId as Record<string, unknown>)
        ? String((entityId as Record<string, unknown>)._id)
        : String(entityId ?? '');
    if (entityType !== 'institutions' || !OBJECT_ID.test(id)) {
        return undefined;
    }
    return type && DUE_TYPES.includes(type) ? `/partner/call/${id}?quick=due` : `/partner/call/${id}`;
}

/** Call view of a notification's school (payload entityType/entityId) */
export function partnerNotificationPath(notification: { type?: string; messagePayload?: unknown }): string | undefined {
    const payload = notification.messagePayload && typeof notification.messagePayload === 'object'
        ? notification.messagePayload as Record<string, unknown>
        : {};
    return partnerCallPath(notification.type, payload.entityType, payload.entityId);
}

/**
 * Partner target of an office path that is not about a school: to-do lists (e.g. the overdue digest) open „Heute“ with the
 * due follow-ups, partner pages stay; everything else has no partner page (undefined: shown without link)
 */
export function partnerOfficePath(path: string | undefined): string | undefined {
    if (!path) {
        return undefined;
    }
    if (path === '/partner' || path.startsWith('/partner/') || path.startsWith('/partner?')) {
        return path;
    }
    return path === '/todos' || path.startsWith('/todos/') || path.startsWith('/todos?') ? '/partner' : undefined;
}
